export default __webpack_public_path__ + "static/media/NYFW.4ed5c0b9.jpeg";